module.exports = __webpack_public_path__ + "static/media/refurbishKitchen.f18eafd4.jpg";